import debuger from 'debug'

import errorTrackingService from 'utils/services/errorTrackingService'

import { DataPreloadManager, PreloadTask } from './types'

const debug = debuger('FlowChartDataPreloader')

enum JobStatus {
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAILED = 'failed',
}

interface Job {
  promise: Promise<boolean>
  status: JobStatus
}

export class DefaultDataPreloadManager implements DataPreloadManager {
  private jobs: Map<string, Job> = new Map()

  private reportFailedJob = (taskKey: string, error: Error) =>
    errorTrackingService.trackError('Data preload job failed unexpectedly', {
      extra: {
        error: error?.message,
        taskKey,
      },
    })

  private createJob = (task: PreloadTask): Job => ({
    status: JobStatus.PROCESSING,
    promise: task.load(),
  })

  private processTask = (task: PreloadTask) => {
    const existingJob = this.jobs.get(task.key)
    if (existingJob && existingJob.status !== JobStatus.FAILED) {
      debug(`Task "${task.key}" is skipped`)
      return Promise.resolve()
    }

    const job = this.createJob(task)

    this.jobs.set(task.key, job)

    debug(`Started task: "${task.key}"`)

    return job.promise
      .then((result) => {
        job.status = result ? JobStatus.SUCCESS : JobStatus.FAILED
        debug(`Finished with result "${job.status}": "${task.key}"`)
      })
      .catch((error): void => {
        this.reportFailedJob(task.key, error)
        job.status = JobStatus.FAILED
        debug(`Failed task: "${task.key}"`)
      })
  }

  public preloadData = (tasks: PreloadTask[]) => tasks.map((task) => this.processTask(task))
}
